import React from 'react';
import { Col, Row } from 'reactstrap';

import Accordion from '../../../../components/Accordion';
import AccordionItem from '../../../../components/Accordion/components/AccordionItem';
import FixedAnchorageDepth from './FixedAnchorageDepth';
import LoadSelector from './LoadSelector';
import { APP_TEXTS } from '../../../../texts/texts';
import { brandList, standardList } from '../../../..//app.values';
import { BRAND } from '@config';
import WorkingLife from './WorkingLife';

const GeneralCalculationDesign = (props) => (
  <Row>
    <Col sm="12">
      <Accordion className="application__accordion" appStatus={props.appStatus}>
        <AccordionItem id="loads" title={
          Number(props.designStd) === standardList['Masonry'] ? 
            APP_TEXTS.DESIGN_LOADS_COMBINATION.Content : APP_TEXTS.DESIGN_LOADS_COMBINATION_ANCHOR_DEPTH.Content}>
          <LoadSelector />
          <FixedAnchorageDepth />
        </AccordionItem>

        {((BRAND === brandList.Ramset || BRAND === brandList.Sea || BRAND === brandList.Spit) && 
          (Number(props.designStd) === standardList['EU'] || Number(props.designStd) === standardList['AS5216'])) && (
          <AccordionItem id="working_life" title={APP_TEXTS.WORKING_LIFE.Content}>
            <WorkingLife />
          </AccordionItem>
        )}
      </Accordion>
    </Col>
  </Row>
);

export default GeneralCalculationDesign;



// WEBPACK FOOTER //
// ./src/views/Design/components/GeneralCalculationDesign/GeneralCalculationDesign.js